<template>
  <div class="screen-wrapper">
    <div class="screen" id="screen">
      <div class="header">
        <div class="company-name">{{company.name}}</div>
        <div class="title">养殖尾水监测</div>
        <div class="weather">
          <iframe name="weather_inc" src="//i.tianqi.com/index.php?c=code&id=10&color=black" width="240" height="25" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" ></iframe>
          <div>{{time}}</div>
        </div>
      </div>
      <div class="content">
        <div class="search">
          <el-select v-model="formData.iotName">
            <el-option v-for="item in equipmentList" :key="item.iotName" :label="item.name" :value="item.iotName" />
          </el-select>
          <span style="margin: 0 20px 0 50px;">时间</span>
          <el-date-picker v-model="formData.dStart" type="date" :clearable="false" value-format="yyyy-MM-dd" style="width: 140px;" />
          <span class="spr-line"></span>
          <el-date-picker v-model="formData.dEnd" type="date" :clearable="false" value-format="yyyy-MM-dd" style="width: 140px;" />
          <el-button type="primary" @click="getSensorChartDataDto" style="margin-left: 30px;">查询</el-button>
          <el-button type="success" @click="exportData">导出数据</el-button>
          <el-button type="primary" icon="el-icon-back" circle style="position: absolute;top: 0;left:-70px;" @click="back"></el-button>
        </div>
        <div class="chart-box">
          <div class="chart-box-radio">
            <el-radio-group v-model="section">
              <el-radio-button label="一天内"></el-radio-button>
              <el-radio-button label="两天内"></el-radio-button>
              <el-radio-button label="三天内"></el-radio-button>
              <el-radio-button label="四天内"></el-radio-button>
              <el-radio-button label="五天内"></el-radio-button>
            </el-radio-group>
          </div>
          <div class="chart" ref="chartRef" v-show="!showNoData"></div>
          <div class="no-data" v-show="showNoData">
            <img src="./images/icon_data_empty.png" alt="">
            <span>该条件下暂无数据</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSensorChartDataDto, getEquipmentsData, getCompanyName } from "@/service/apiData.js"
import { Loading } from 'element-ui'

let endDate = new Date(
  new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
)
let today = new Date()
today.setHours(0)
today.setMinutes(0)
today.setSeconds(0)
today.setMilliseconds(0)
let oneday = 1000 * 60 * 60 * 24
let threeDay = 1000 * 60 * 60 * 24 * 2
let fourDay = 1000 * 60 * 60 * 24 * 3
let fiveDay = 1000 * 60 * 60 * 24 * 4

export default {
  name: 'tailWaterMonitoringChart',
  components: {
  },
  data () {
    return {
      // 公司信息
      company: {},
      equipmentList: [],
      time: '',
      section: '一天内',
      formData: {
        id: '', // 设备Id
        iotName: '', // 插孔第三方名称，由设备服务给出
        dStart: '', // 开始时间
        dEnd: '' // 结束时间
      },
      legend: [],
      series: [],
      xAxisData: [],
      showNoData: false,
    }
  },
  computed: {},
  props: ['chartRequestParams'],
  methods: {
    // 获取数据
    async getSensorChartDataDto () {
      this.showNoData = false
      var loadinginstace = Loading.service({ fullscreen: true, background: '#00000000', text: '加载中' })
      const params = {}
      Object.assign(params, this.formData)
      // TODO: 测试用
      // params.dEnd = "2022-01-14"
      // params.dStart = "2022-01-13"
      // params.id = "636089367965017387"
      // params.iotName = "0"
      // TODO: 测试用
      params.dStart = params.dStart + ' 00:00:00'
      params.dEnd = params.dEnd + ' 23:59:59'
      const { data } = await getSensorChartDataDto(params)
      this.initData(data)
      this.initChart()
      loadinginstace.close()
      if(data.length === 0){
        this.showNoData = true
      }
    },
    // 格式化获取到的数据
    initData(chartData){
      const colorArr = [
        ['#0055F8FF', '#0055F810'],
        ['#F9CA5EFF', '#F9CA5E10'],
        ['#FF2073FF', '#FF207310'],
        ['#AE24FEFF', '#AE24FE10'],
        ['#AE24FEFF', '#AE24FE10'],
      ]
      // TODO: 测试用
      // const arr = this.getDateSection('2022-01-13', '2022-01-14')
      const arr = this.getDateSection(this.formData.dStart, this.formData.dEnd)
      this.legend = arr
      const { timeList, seriesArr } = this.init2(chartData, arr)
      this.xAxisData = timeList
      seriesArr.forEach( (item, index) => {
        this.series.push({
          type: 'line',
          name: item.name,
          data: item.data,
          smooth: true,
          showSymbol: false,
          lineStyle: {
            color: colorArr[index][0]
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: colorArr[index][0]
              },
              {
                offset: 1,
                color: colorArr[index][1]
              }
            ])
          }
        })
      })
    },
    init2(chartData, dateList){
      let timeList = chartData.map( data => data.moment)
      timeList = [...new Set(timeList)]
      const arr = []
      dateList.forEach( curdate => {
        let dataArr = []
        timeList.forEach( timeItem => {
          const res = chartData.find( data => data.date === curdate && data.moment === timeItem )
          if (res) {
            dataArr.push(res.value)
          } else {
            dataArr.push(0)
          }
        })
        arr.push({
          name: curdate,
          data: dataArr
        })
      })
      return { timeList, seriesArr: arr }
    },
    getDateSection(startDate, endDate){
      let arr = []
      // 获取两日期之间日期列表函数
      // 初始化日期列表，数组
      let diffdate = new Array();
      let i = 0;
      // 开始日期小于等于结束日期,并循环
      while (startDate <= endDate) {
        diffdate[i] = startDate;

        //获取开始日期时间戳
        let startDate_ts = new Date(startDate).getTime();
        arr.push(startDate)
        //增加一天时间戳后的日期
        let next_date = startDate_ts + 24 * 60 * 60 * 1000;

        //拼接年月日，这里的月份会返回（0-11），所以要+1
        let next_dates_y = new Date(next_date).getFullYear() + "-";
        let next_dates_m = new Date(next_date).getMonth() + 1 < 10 ? "0" + (new Date(next_date).getMonth() + 1) + "-" : new Date(next_date).getMonth() + 1 + "-";
        let next_dates_d = new Date(next_date).getDate() < 10 ? "0" + new Date(next_date).getDate() : new Date(next_date).getDate();

        startDate = next_dates_y + next_dates_m + next_dates_d;

        //增加数组key
        i++;
      }
      return arr
    },
    async getEquipmentsData () {
      const { data } = await getEquipmentsData()
      const equipmentList = data.sensorEquipments.find( item => item.id === this.formData.id)
      this.equipmentList = equipmentList.sensors.map( item => {
        return {
          name: item.name,
          iotName: item.iotName,
        }
      })
    },
    handleScreenAuto () {
      return
      const designDraftWidth = 1920 // 设计稿的宽度
      const designDraftHeight = 936 // 设计稿的高度
      // 根据屏幕的变化适配的比例
      const scale =
        document.documentElement.clientWidth /
          document.documentElement.clientHeight <
        designDraftWidth / designDraftHeight
          ? document.documentElement.clientWidth / designDraftWidth
          : document.documentElement.clientHeight / designDraftHeight
      // 缩放比例
      document.querySelector('#screen').style.transform = `scale(${scale}) translate(-50%)`
    },
    // 获取公司信息
    async getCompanyName () {
      const { data } = await getCompanyName()
      this.company = data
    },
    formatterTime () {
      let time = this.$timeformat(new Date());
      time = time.split('-')
      time = `${time[0]}年${time[1]}月${time[2]}`
      time = time.split('  ')
      this.time = `${time[0]}日 ${time[1]}`
    },
    initFormData () {
      // 保存参数
      Object.assign(this.formData, this.chartRequestParams)
      this.formData.dStart = this.$timeformatDay(new Date())
      this.formData.dEnd = this.$timeformatDay(new Date())
    },
    // 导出数据
    exportData () {

    },
    back(){
      this.$emit('back')
    },
    // 初始化图表
    initChart () {
      this.chart = this.$echarts.init(this.$refs.chartRef)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        legend: {
          bottom: 0,
          data: this.legend
        },
        color:['#0055F8', '#F9CA5E', '#FF2073', '#AE24FE', '#AE24FE'],
        grid: {
          top: 50,
          right: 20,
          bottom: 50,
          left: 30,
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#E6E6E6',
            }
          },
          splitLine: {
            lineStyle: {
              color: '#E6E6E6',
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#333',
            fontWeight : 500,
            fontSize: 20,
          }
        },
        series: this.series
      }
      this.chart.setOption(option)
    },
  },
  mounted () {
    // 格式化搜索参数
    this.initFormData()
    // 屏幕适配
    this.handleScreenAuto()
    window.onresize = () => this.handleScreenAuto()
    // 获取图表数据
    this.getSensorChartDataDto()
    // 获取设备选择列表
    this.getEquipmentsData()
    // 获取公司信息
    this.getCompanyName()
    // 格式时间
    this.formatterTime()
    setInterval(() => { this.formatterTime() }, 1000);
  },
  deleted () {
    window.onresize = null
  },
  watch: {
    section(date) {
      if (date === '一天内') {
        this.formData.dStart = this.$timeformatDay(today)
        this.formData.dEnd = this.$timeformatDay(endDate)
        this.getSensorChartDataDto()
      }
      if (date === '两天内') {
        this.formData.dStart = this.$timeformatDay(new Date(today - oneday))
        this.formData.dEnd = this.$timeformatDay(endDate)
        this.getSensorChartDataDto()
      }
      if (date === '三天内') {
        this.formData.dStart = this.$timeformatDay(new Date(today - threeDay))
        this.formData.dEnd = this.$timeformatDay(endDate)
        this.getSensorChartDataDto()
      }
      if (date === '四天内') {
        this.formData.dStart = this.$timeformatDay(new Date(today - fourDay))
        this.formData.dEnd = this.$timeformatDay(endDate)
        this.getSensorChartDataDto()
      }
      if (date === '五天内') {
        this.formData.dStart = this.$timeformatDay(new Date(today - fiveDay))
        this.formData.dEnd = this.$timeformatDay(endDate)
        this.getSensorChartDataDto()
      }
    },
    "formData.dStart"(startDate) {
      if (this.section === '一天内') {
        this.formData.dStart = this.$timeformatDay(new Date(new Date(startDate).toLocaleDateString()).getTime())// 00:00:00
        let a = new Date(startDate).getTime()
        this.formData.dEnd = this.$timeformatDay(new Date(new Date(a).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)// 23:59分59秒
      }
      if (this.section === '两天内') {
        this.formData.dStart = this.$timeformatDay(new Date(new Date(startDate).toLocaleDateString()).getTime())// 00:00:00
        let a = new Date(startDate).getTime()
        this.formData.dEnd = this.$timeformatDay(new Date(new Date(a).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1 + 24 * 3600 * 1000)
      }
      if (this.section === '三天内') {
        this.formData.dStart = this.$timeformatDay(new Date(new Date(startDate).toLocaleDateString()).getTime())// 00:00:00
        let a = new Date(startDate).getTime()
        this.formData.dEnd = this.$timeformatDay(new Date(new Date(a).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1 + 2 * 24 * 3600 * 1000)
      }
      if (this.section === '四天内') {
        this.formData.dStart = this.$timeformatDay(new Date(new Date(startDate).toLocaleDateString()).getTime())// 00:00:00
        let a = new Date(startDate).getTime()
        this.formData.dEnd = this.$timeformatDay(new Date(new Date(a).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1 + 3 * 24 * 3600 * 1000)
      }
      if (this.section === '五天内') {
        this.formData.dStart = this.$timeformatDay(new Date(new Date(startDate).toLocaleDateString()).getTime())// 00:00:00
        let a = new Date(startDate).getTime()
        this.formData.dEnd = this.$timeformatDay(new Date(new Date(a).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1 + 4 * 24 * 3600 * 1000)
      }
    },
    "formData.dEnd"(endDate) {
      if (this.section === '一天内') {
        this.formData.dEnd = this.$timeformatDay(endDate)
        let a = new Date(endDate).getTime()
        this.formData.dStart = a
      }
      if (this.section === '两天内') {
        this.formData.dEnd = this.$timeformatDay(endDate)
        let a = new Date(endDate).getTime()
        this.formData.dStart = a - 1 * 24 * 3600 * 1000
      }
      if (this.section === '三天内') {
        this.formData.dEnd = this.$timeformatDay(endDate)
        let a = new Date(endDate).getTime()
        this.formData.dStart = a - 2 * 24 * 3600 * 1000
      }
      if (this.section === '四天内') {
        this.formData.dEnd = this.$timeformatDay(endDate)
        let a = new Date(endDate).getTime()
        this.formData.dStart = a - 3 * 24 * 3600 * 1000
      }
      if (this.section === '五天内') {
        this.formData.dEnd = this.$timeformatDay(endDate)
        let a = new Date(endDate).getTime()
        this.formData.dStart = a - 4 * 24 * 3600 * 1000
      }
    },
  },
}
</script>
<style scoped lang="stylus">
.screen-wrapper {
  width: 100%;
  height: 100%;
  background-image: url(./images/bg.png);
  background-size: 100% 100%;
  repeat: no-repeat;
  .screen {
    display: inline-block;
    // width: 1920px;
    width: 100%;
    // height: 936px;
    // transform-origin: 0 0;
    // position: absolute;
    // left: 50%;
    display: flex;
    flex-direction: column;
    .header{
      width: 100%;
      height: 64px;
      background: #C7DEFE;
      padding: 16px 24px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .company-name{
        font-size: 24px;
        font-weight: 500;
        color: #001133;
      }
      .title{
        font-size: 28px;
        font-weight: 600;
        color: #001133;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .weather{
        display: flex;
        align-items: center;
      }
    }
    .content{
      width: 100%;
      flex: 1;
      padding: 0 70px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .search{
        display: flex;
        align-items: center;
        margin: 20px 0;
        position: relative;
        .spr-line{
          display: inline-block;
          width: 20px;
          border: 1px solid #3387FE;
          margin: 0 10px;
        }
      }
      .chart-box{
        // width: 1760px;
        height: 650px;
        background: #F8F9FB;
        box-shadow: 6px 6px 24px 1px rgba(0,7,39,0.08);
        border-radius: 10px;
        padding: 32px 64px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        .chart-box-radio{
          text-align: right;
        }
        .chart{
          flex: 1;
          margin-top: 10px;
        }
        .no-data{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img{
            width: 300px;
          }
          span{
            font-size: 50px;
          }
        }
      }
    }
  }
}
</style>
<style>
.screen-wrapper .screen .content>.search input.el-input__inner{
  border-color: #3A8BFE;
}
</style>
